import { memo } from 'react';

import Config from '../../../../config';
import coinImage from '../../../../assets/images/coins/skipped-coin-80.svg';
import IconModal from '../../../../components/IconModal';

export interface IPwaInstallBonusDialogProps {
    open: boolean;
    bonusCoins: number;
    onClose: () => void;
}

export const PwaInstallBonusDialog = memo(({ open, bonusCoins, onClose }: IPwaInstallBonusDialogProps) => {
    const coins = bonusCoins > 0 ? bonusCoins : Config.PWA_INSTALL_BONUS_COINS;

    return (
        <IconModal
            title="App-Bonus erhalten!"
            text={`Danke fürs Installieren! Du hast ${coins} ${Config.GLOBAL_SITE_COINS} erhalten.`}
            icon={coinImage}
            open={open}
            onClose={onClose}
        />
    );
});

export default PwaInstallBonusDialog;
